var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var clearFix = function () { return ({
    ':before': {
        content: '" "',
        display: 'table',
    },
    ':after': {
        content: '" "',
        display: 'table',
        clear: 'both',
    },
}); };
var icon = {
    // eslint-disable-next-line quotes
    dismiss: "data:image/svg+xml,%3Csvg baseProfile='tiny' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='XXXXX' d='M16 .703L15.298 0 8 7.298.702 0 0 .703 7.298 8 0 15.297.702 16 8 8.702 15.298 16l.702-.703L8.702 8z'/%3E%3C/svg%3E",
    // eslint-disable-next-line quotes
    info: "data:image/svg+xml,%3Csvg width='128' height='128' viewBox='0 0 128 128' xmlns='http://www.w3.org/2000/svg'%3E%3Ctitle%3Eregular/info-circle%3C/title%3E%3Cpath fill='XXXXX' d='M64 128C28.654 128 0 99.346 0 64 0 28.654 28.654 0 64 0c35.346 0 64 28.654 64 64 0 35.346-28.654 64-64 64zm0-8c30.928 0 56-25.072 56-56S94.928 8 64 8 8 33.072 8 64s25.072 56 56 56zm.5-96.25c3.333.167 6.125 1.375 8.375 3.625s3.375 5.083 3.375 8.5-1.125 6.25-3.375 8.5-5.083 3.375-8.5 3.375-6.25-1.125-8.5-3.375-3.375-5.083-3.375-8.5 1.125-6.25 3.375-8.5S61 23.917 64.5 23.75zm20 67.49c0 .558-.23 1.383-.546 1.842 0 0-.954 1.918-5.329 5.293S69 104 61 104c-4 0-7.75-1.125-10-3s-3.506-4.752-2.75-8.75C50 83 54.5 65 54.5 65c.333-2.5-.667-4.083-3-4.75l-4.275-1.018c-.538-.128-.975-.675-.975-1.231v-1.002c0-.552.45-.999 1-.999H71c1 0 1.792.417 2.375 1.25s.708 1.75.375 2.75c0 0-4.75 22-5.75 26-1.461 5.846.833 7.75 4 7.75 4-.167 7.083-1.083 9.25-2.75s2.512-2.066 2.512-2.066c.408-.378.738-.24.738.325v1.982z'  fill-rule='evenodd'/%3E%3C/svg%3E",
    // eslint-disable-next-line quotes
    warning: "data:image/svg+xml,%3Csvg width='128' height='128' viewBox='0 0 128 128' xmlns='http://www.w3.org/2000/svg'%3E%3Ctitle%3Eregular/exclamation-triangle%3C/title%3E%3Cpath fill='XXXXX' d='M45.906 14.787c9.973-19.716 26.142-19.717 36.116 0l42.79 84.589c7.977 15.77.108 28.555-17.56 28.555H20.676c-17.675 0-25.536-12.787-17.56-28.555l42.79-84.589zm7.139 3.611l-42.79 84.589c-5.284 10.447-1.29 16.944 10.421 16.944h86.576c11.708 0 15.705-6.498 10.42-16.944L74.885 18.398c-7.014-13.864-14.826-13.864-21.84 0zM64.5 26c2.333 0 4.25.667 5.75 2s2.25 3 2.25 5c0 .667-.083 1.833-.25 3.5l-1.922 49.497A2.098 2.098 0 0 1 68.25 88h-6.5a2.167 2.167 0 0 1-2.137-2L56.25 37c-.167-1.5-.25-2.417-.25-2.75 0-2.833.75-4.917 2.25-6.25 1.333-1.333 3.417-2 6.25-2zm-.125 85.5c-2.25 0-4.208-.792-5.875-2.375-1.667-1.583-2.5-3.583-2.5-6s.75-4.292 2.25-5.625c1.833-1.667 3.875-2.5 6.125-2.5s4.167.792 5.75 2.375c1.583 1.583 2.375 3.542 2.375 5.875s-.75 4.333-2.25 6c-1.667 1.5-3.625 2.25-5.875 2.25z'  fill-rule='evenodd'/%3E%3C/svg%3E",
};
var getIcon = function (icon, size, fill, label) {
    if (label === void 0) { label = undefined; }
    var fillEncoded = fill.replace('#', '%23');
    var dataUri = icon.replace('XXXXX', fillEncoded);
    return {
        label: label,
        display: 'inline-block',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: "url(\"".concat(dataUri, "\")"),
        width: size,
        height: size,
    };
};
export var dismissIcon = getIcon(icon.dismiss, 16, '#044766');
export var dismissIconWarning = getIcon(icon.dismiss, 16, '#ab2811');
export var infoIcon = getIcon(icon.info, 20, '#044766');
export var warningIcon = getIcon(icon.warning, 20, '#ab2811');
var reset = {
    backgroundAttachment: 'scroll',
    backgroundClip: 'border-box',
    backgroundOrigin: 'padding-box',
    backgroundSize: 'auto',
    fontFamily: '"Open Sans", Helvetica, Arial, sans-serif',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '14px',
    textSizeAdjust: '100%',
};
export var callout = __assign(__assign(__assign({}, clearFix()), reset), { alignItems: 'center', boxShadow: 'unset', boxSizing: 'border-box', display: 'flex', overflow: 'hidden', padding: 12, position: 'relative', width: '100%', marginBottom: 16, borderRadius: '2px' });
export var calloutInformation = __assign(__assign({}, callout), { background: '#dff4f8', color: '#044766' });
export var calloutWarning = __assign(__assign({}, callout), { background: '#ffe7c4', color: '#ab2811', h3: {
        color: '#ab2811',
    } });
export var iconContainer = {
    alignSelf: 'flex-start',
    display: 'flex',
    paddingRight: 12,
};
export var contentWrapper = {
    alignItems: 'flex-start',
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
};
export var message = {
    alignItems: 'flex-start',
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    lineHeight: "".concat(20, "px"),
};
export var title = {
    color: '#044766',
    display: 'flex',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '20px',
    marginBottom: '4px',
    paddingRight: 12,
};
export var actions = {
    alignItems: 'center',
    display: 'flex',
    paddingLeft: 12,
    alignSelf: 'flex-start',
};
